(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('CareTeamSearch', CareTeamSearch);

    CareTeamSearch.$inject = ['$resource'];

    function CareTeamSearch($resource) {
        var resourceUrl =  'api/_search/care-teams/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
